// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ylgrylnvwaluadcjrkff.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlsZ3J5bG52d2FsdWFkY2pya2ZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc0Nzg4OTAsImV4cCI6MjA2MzA1NDg5MH0.bO63D1iqFHinSZO7UPG89IHbG_uIlAptgnr850c4ZDY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});